<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
    <h1>{{ 'turbo.core.ServiceBookingDialog.txtHeadline' | translate : 'Service booking' }}</h1>
    <t4-periodPicker [(from)]="startDate" [(to)]="endDate" period="day"></t4-periodPicker>
    <t4-container title="{{ 'turbo.core.ServiceBookingDialog.lblTime' | translate : 'Time' }}">
        <mat-checkbox style="margin-right: 15px;" [(ngModel)]="allDay">{{ 'turbo.core.ServiceBookingDialog.chkAllDay' | translate : 'All day' }}</mat-checkbox>
        <div class="row" *ngIf="!allDay">
            <div class="col-xs-6">
                <h5>{{ 'Turbo.core.ServiceBookingDialog.lblStartTime' | translate : 'Start time' }}</h5>
                <t4-timePicker [(selectedTime)]="startTime" steps="hour"></t4-timePicker>
            </div>
            <div class="col-xs-6">
                <h5>{{ 'Turbo.core.ServiceBookingDialog.lblEndTime' | translate : 'End time' }}</h5>
                <t4-timePicker [(selectedTime)]="endTime" steps="hour"></t4-timePicker>
            </div>
        </div>
    </t4-container>
    <t4-container title="{{ 'turbo.core.ServiceBookingDialog.lblTrailers' | translate : 'Affected objects' }}">
      <mat-checkbox  style="position:absolute; margin-right:20px; right:0;" [checked]="showDisabled" (change)="onToggleShowDisabled($event)">Show disabled</mat-checkbox>
      <t4-objectList [locationId]="Settings.clientSettings.RentalLocationId" [includeDisabled]="showDisabled" [multiSelect]="true" height="400px" (selectionChanged)="objectsChanged($event)"></t4-objectList>
    </t4-container>
    </mat-dialog-content>
        <mat-dialog-actions>
            <button style="float: right; margin-top: 10px;" mat-flat-button color="primary" [disabled]="!isValid" (click)="createServiceBookings()">{{ 'turbo.core.ServiceBookingDialog.cmdCreate' | translate : 'Create' }}</button>
        </mat-dialog-actions>
        <div class="loader" *ngIf="loading.dialog">
            <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
            <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading.dialog"></mat-progress-bar>
        </div>
